import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Reveal a single string word-by-word (used only for plain text).
export default function MaskedReveal({
  text,
  as: Tag = "span",
  delay = 0,
  stagger = 0.06,
  className = "",
  testId,
}) {
  const words = text.split(" ");
  return (
    <Tag data-testid={testId} className={className}>
      {words.map((w, i) => (
        <span key={i} className="reveal-mask mr-[0.28em] last:mr-0">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              ease: EASE,
              delay: delay + i * stagger,
            }}
            className="inline-block"
          >
            {w}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

// Reveal multiple lines. Each item can be:
//   - a string → animated word by word
//   - a React node → animated as one block
export function MaskedRevealLines({
  lines = [],
  as: Tag = "h1",
  className = "",
  lineClassName = "",
  wordStagger = 0.05,
  lineStagger = 0.15,
  baseDelay = 0.1,
  ariaLabel,
  testId,
}) {
  return (
    <Tag data-testid={testId} aria-label={ariaLabel} className={className}>
      {lines.map((line, li) => {
        const isString = typeof line === "string";
        return (
          <span key={li} className={`block ${lineClassName}`}>
            {isString ? (
              line.split(" ").map((w, i) => (
                <span key={i} className="reveal-mask mr-[0.28em] last:mr-0">
                  <motion.span
                    initial={{ y: "110%", opacity: 0 }}
                    animate={{ y: "0%", opacity: 1 }}
                    transition={{
                      duration: 0.9,
                      ease: EASE,
                      delay: baseDelay + li * lineStagger + i * wordStagger,
                    }}
                    className="inline-block"
                  >
                    {w}
                  </motion.span>
                </span>
              ))
            ) : (
              <span className="reveal-mask block">
                <motion.span
                  initial={{ y: "110%", opacity: 0 }}
                  animate={{ y: "0%", opacity: 1 }}
                  transition={{
                    duration: 1,
                    ease: EASE,
                    delay: baseDelay + li * lineStagger,
                  }}
                  className="inline-block"
                >
                  {line}
                </motion.span>
              </span>
            )}
          </span>
        );
      })}
    </Tag>
  );
}
